var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row gap-3 mb-4"},[_c('button',{staticClass:"bg-level-h severity-btn",class:{
      'shadow-lg': _vm.selected_severity == 3,
      'shadow-sm': _vm.selected_severity != 3,
      'opacity-100': _vm.selected_severity == 3,
      'opacity-50': _vm.selected_severity != 3,
    },on:{"click":function($event){return _vm.set_selected_severity(3)}}},[_vm._v(" H ")]),_c('button',{staticClass:"bg-level-m severity-btn transform",class:{
      'shadow-lg': _vm.selected_severity == 2,
      'shadow-sm': _vm.selected_severity != 2,
      'opacity-100': _vm.selected_severity == 2,
      'opacity-50': _vm.selected_severity != 2,
    },on:{"click":function($event){return _vm.set_selected_severity(2)}}},[_vm._v(" M ")]),_c('button',{staticClass:"bg-level-l severity-btn transform",class:{
      'shadow-lg': _vm.selected_severity == 1,
      'shadow-sm': _vm.selected_severity != 1,
      'opacity-100': _vm.selected_severity == 1,
      'opacity-50': _vm.selected_severity != 1,
    },on:{"click":function($event){return _vm.set_selected_severity(1)}}},[_vm._v(" L ")])])}
var staticRenderFns = []

export { render, staticRenderFns }